import { Tag } from 'antd';
import { Interweave } from 'interweave';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Div, Flex, Icon } from 'ui';
import { announcementCategoryColors } from '../../../utils/app-configs';
import { isObjectNullOrEmpty } from '../../../utils/helpers';

const Card = styled(Div)`
  border-radius: 10px;
  padding: 5px 10px 10px 10px;
  box-shadow: 0 0 5px #A9BEC8;
`;

const Title = styled(Div)`
  font-size: 20px;
  color: ${p => p.theme.colors.theme};
  font-weight: bold;
`;

const StyledTag = styled(Tag)`
  margin: 0;
`;

const StyledIcon = styled(Icon)`
    margin-right: 10px;

    ${p => p?.severity === 'informational' && `
        color: ${p.theme.colors.alerts[3]} !important;
    `}

    ${p => p?.severity === 'moderate' && `
        color: ${p.theme.colors.alerts[2]} !important;
    `}

    ${p => p?.severity === 'high' && `
        color: ${p.theme.colors.alerts[1]} !important;
    `}
`;

const ContentWrapper = styled(Div)`
  overflow-wrap: break-word;

  img {
    max-width: 100%;
  }
  .description-field ul {
    margin-bottom: 0px;
    &[data-checked=false] {
      padding-left: 20px;
      list-style: none;
      li::before {
        content: '\\2610';
        cursor: pointer;
        margin-right: 10px;
      } 
    }
    &[data-checked=true] {
      padding-left: 20px;
      list-style: none;
      li::before {
        content: '🗹';
        cursor: pointer;
        margin-right: 10px;
      } 
    }
  }
  .instruction-field a {
    text-decoration: underline;
  }
`;

const AnnouncementCard = ({
  announcement,
}) => isObjectNullOrEmpty(announcement) ?
    null :
    <Card marginBottom={10} key={announcement.id}>
      <Flex aic jcsb marginBottom={5}>
        <Flex aib>
          <StyledIcon type={announcement?.severity?.icon} severity={announcement?.severity?.id} />
          <Title data-test-id='announcement-card-title'>{announcement.title}</Title>
        </Flex>
        <StyledTag
          color={announcementCategoryColors[announcement?.category?.id]}
          data-test-id='announcement-card-category'
        >
          {announcement?.category?.description}
        </StyledTag>
      </Flex>
      <ContentWrapper data-test-id='announcement-card-description' >
        <Interweave content={announcement.message} className='description-field' />
      </ContentWrapper>
    </Card>;

AnnouncementCard.propTypes = {
  announcement: PropTypes.object,
};

export default AnnouncementCard;
